import { formatCellValue } from "@/components/contracts/table-utils";

type FieldValue = string | number | boolean | undefined;

/** Renders `{label, value}` pairs as a compact grid, skipping unset optional fields. */
export function FieldGrid({ fields }: { fields: { label: string; value: FieldValue }[] }) {
  const visible = fields.filter((f) => f.value !== undefined && f.value !== "");
  if (visible.length === 0) return null;

  return (
    <dl className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm sm:grid-cols-3 lg:grid-cols-4">
      {visible.map((f) => (
        <div key={f.label}>
          <dt className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            {f.label}
          </dt>
          <dd className="font-medium break-words">{formatCellValue(f.value)}</dd>
        </div>
      ))}
    </dl>
  );
}
